const processStatus = {
  0: { name: 'execution', label: 'global.status.running' },
  1: { name: 'approved', label: 'global.status.approved1' },
  2: { name: 'rejected', label: 'global.status.rejected1' },
  3: { name: 'canceled', label: 'global.status.canceled1' },
  4: { name: 'voided', label: 'global.status.voided1' },
  5: { name: 'error', label: 'global.status.error' },
  6: { name: 'execution', label: 'global.status.running' },
};

const actionStatus = {
  0: { name: 'pending' },
  1: { name: 'finished' },
  2: { name: 'rejected' },
  3: { name: 'overdue' },
};

const processInstance = {
  0: 'global.status.running',
  1: 'global.status.approved1',
  2: 'global.status.rejected1',
  3: 'global.status.canceled1',
  4: 'global.status.voided1',
  5: 'global.status.error',
};

const actionInstance = {
  0: 'global.status.pending1',
  1: 'global.status.finished1',
  2: 'global.status.rejected1',
  3: 'global.status.overdue',
};

const monthRequests = {
  0: 'global.status.running',
  1: 'global.status.approved',
  2: 'global.status.rejected',
  5: 'global.status.error',
  3: 'global.status.canceled',
  4: 'global.status.voided',
};

const taskStatus = {
  1: { name: 'complete', label: 'task.status.complete' },
  2: { name: 'approved', label: 'task.status.approved' },
  5: { name: 'execution', label: 'task.status.execution' },
  8: { name: 'signature', label: 'task.status.signature' },
};

export default {
  actionStatus,
  processStatus,
  processInstance,
  actionInstance,
  monthRequests,
  taskStatus,
};
